export const initialScannerConfiguration = {
	title: "",
	expiration_time: "",
	apikey: "",
	events: [],
	sections: [],
	device_name: "",
};

export const initialScanSettings = {
	scanDelay: 3000,
	keepScanPopupOpen: false,
	logging: false,
	autoUpdate: true,
	updateInterval: 60000,
	device_name: "",
	muted: false,
};

export const initialUserSettings = {
	language: "fi",
	handedness: "right",
	wakelock: false,
};

export const initialScanMode = {
	mode: "entry",
	section: null,
	sectionName: null,
	timeTolerance: "0",
	expiredTicketAcceptance: false,
};

export const boothSettings = {
	allowed_booth_names: [],
	booth_mode_only: false,
};
